export default __webpack_public_path__ + "static/img-2-c97006c981c95670965786a11c1a2f16.png";